import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ProgramView } from './ProgramView'
import { programApi } from './api'
import type { PublicProgram } from './api'
export function ProgramPage() {
  const { slug = '' } = useParams<{ slug: string }>()
  const [program, setProgram] = useState<PublicProgram | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)
  const fixtures = import.meta.env.DEV && import.meta.env.VITE_PROGRAM_FIXTURES === '1'
  useEffect(() => {
    let active = true
    setLoading(true)
    setError(false)
    setProgram(null)
    const load = fixtures
      ? import('./fixtures').then((m) => {
          if (slug === 'rehearsal-unavailable') throw new Error('Synthetic unavailable fixture')
          return m.programFixtures[slug] ?? null
        })
      : programApi.public(slug)
    void load
      .then((value) => {
        if (active) setProgram(value)
      })
      .catch(() => {
        if (active) setError(true)
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [slug, attempt, fixtures])
  useEffect(() => {
    const old = document.title
    if (program) document.title = `${program.show.title} | Digital Program | One Day Dance`
    return () => {
      document.title = old
    }
  }, [program])
  if (loading)
    return (
      <main className="p-8" role="status">
        Loading the program…
      </main>
    )
  if (!program)
    return (
      <main className="mx-auto max-w-xl p-8">
        <h1 className="text-3xl font-bold">
          {error ? 'Program unavailable' : 'Program not published yet'}
        </h1>
        <p className="my-4">
          {error
            ? 'The program could not be loaded. Please try again.'
            : 'This program is not available at this address yet. Check back closer to the show.'}
        </p>
        <button className="min-h-11 rounded border px-4" onClick={() => setAttempt((a) => a + 1)}>
          Try again
        </button>
        <a className="ml-4 inline-block py-3" href="/events">
          Explore events
        </a>
      </main>
    )
  return <ProgramView program={program} preview={fixtures} />
}
